import { render, staticRenderFns } from "./bindRecord.vue?vue&type=template&id=788199ca&scoped=true&"
import script from "./bindRecord.vue?vue&type=script&lang=js&"
export * from "./bindRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788199ca",
  null
  
)

export default component.exports